export default __webpack_public_path__ + "static/media/ba7c138d-6c39-4eeb-8ad0-c46d089ed652.2fd30d38.jpg";